// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yvUi_","title":"styles_title__1l_7W"};